import React, { useCallback, useState } from "react"
import WEDDINGVENUES from '@data/components/submenu/weddingvenues'
import { CategorySearch, LocationSearch } from "@components/Select"
import LinkButton from "@ui/LinkButton"
import { Button } from 'react-bootstrap';
import cl from 'classnames'

import { getAsset, getCountry } from '@helper/getConfigValues'
import { isAbsoluteUrl } from "@helper/isAbsoluteUrl";
import scss from './WeddingVenues.module.scss'

import type { Region } from "@api/getregions"
import type { Category } from "@api/getcategories"

function WeddingVenuesDropdownMenu() {  
  const countryCode = getCountry();
  const data = WEDDINGVENUES[countryCode]
  const [currentRegion, setCurrentRegion] = useState<Region | null>(null);
  const [currentCategory, setCurrentCategory] = useState<Category | null>(null);

  const findSuppliers = useCallback((e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    var url: string = "\\" + (currentCategory?.Slug ?? "wedding") + "\\" + (currentRegion?.Slug ?? "") + (currentRegion ? "\\" : "");
    window.location.href = url;
  }, [currentCategory, currentRegion]);

  return <div className={scss.container}>
    <div className={scss.regions}>
      <div className={scss.subTitle}>Popular <br className="d-none d-xl-block"/>Regions</div>
      <div className={scss.regionLinks}>
        {data.popular_regions.map(({ title, url, target }) => (
          <a key={title} href={url} target={!!target ? target : undefined}>
            {title}
          </a>
        ))}
      </div>
    </div>
    <div className={scss.styles}>
      <div className={scss.stylesTitle}>Popular Styles</div>
      <div className={scss.stylesLinks}>
        {data.popular_styles.map(({ title, url, image }) => (
          <a key={title} className={scss.styleLink} href={url} title={title}>
            <div className={scss.styleImg} style={{ backgroundImage: `url('${isAbsoluteUrl(image) ? image : getAsset(image)}')` }} ></div>
            <div className={scss.styleLinkTitle}>{title}</div>
          </a>
        ))}
      </div>
    </div>
    <div className={scss.search}>
      <div className={`${scss.title} ${scss.textRaisinBlack}`}>Find Trusted Suppliers</div>
      <div className={scss.searchWrapper}>      
        <div className={scss.searchInfo}>          
          <div className={scss.textDavysGrey}>Choose from {countryCode == "au" ? "5,000" : "6,000"}+ wedding venues, services and providers<span className={scss.desktopOnly}> across {countryCode == "au" ? "Australia" : "the UK"}</span>.</div>
        </div>
        <div className={scss.searchForm}>
          <div className={scss.searchSelect}>
            <CategorySearch direction={'up'} currentCategory={currentCategory} setCurrentCategory={setCurrentCategory} />
          </div>
          <div style={{ paddingLeft: '0.5rem', paddingRight: '0.5rem' }}>in</div>
          <div className={scss.searchSelect}>
            <LocationSearch direction={'up'} currentRegion={currentRegion} setCurrentRegion={setCurrentRegion} />
          </div>
          <div>
            <Button onClick={findSuppliers} variant="primary">Search</Button>
          </div>
        </div>
        <LinkButton href="/wedding/" className={cl(scss.searchLink, "text-light")}>Find Suppliers</LinkButton>
      </div>
    </div>
  </div >
}

export default WeddingVenuesDropdownMenu
